import { useEffect, useRef } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

// =============================================================================
// Self-updating PWA
// =============================================================================
// An installed PWA only checks for a new service worker on a full page load
// (or every 24h), so a POS tab that stays open for days never sees deploys.
// Poll for new builds and check again when the app returns to the foreground.
// VitePWA's autoUpdate registration activates the downloaded worker and reloads
// the app automatically, without a prompt or an update button.

const CHECK_EVERY_MS = 5 * 60_000;
export function AppUpdater(): null {
  const registrationRef = useRef<ServiceWorkerRegistration | null>(null);
  useRegisterSW({
    onRegisteredSW(_url, registration) {
      registrationRef.current = registration ?? null;
    },
  });

  useEffect(() => {
    const check = (): void => {
      registrationRef.current?.update().catch(() => {
        /* offline / server unreachable — next tick will retry */
      });
    };
    const onVisible = (): void => {
      if (document.visibilityState === 'visible') check();
    };
    const interval = window.setInterval(check, CHECK_EVERY_MS);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return null;
}
